import onInitModulesInScope from "../scripts/onInitModulesInScope";

import 'popper.js';
import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

import * as tooltip from './tooltip';
tooltip.init();

import * as goToLink from '../libs/@elements/go-to-link';
goToLink.init();


import toastr from "toastr";
import {init} from '../libs/@elements/alert-notification';
init({
    key: (_config && _config['alertNotificationKey']) ? _config['alertNotificationKey'] : '__alertNotification',
    renderFunction: function renderFunction({type, title, content, pogressbar, closable = true, placement, defaultRender} = {}, {$container}) {
        if (content) {
            if (type === 'danger')  {
                type = 'error';
            }
            toastr[type](content, title, {
                positionClass: 'toast-top-right',
                closeButton: closable,
                newestOnTop: true,
                progressBar: pogressbar
            });
        }
    }
});

import * as lazyImg from '../libs/@elements/lazy-img';
onInitModulesInScope(lazyImg.initInScope);

import * as openModalOnLoad from './open-modal-on-load';
openModalOnLoad.init();

//
// import * as actionChanger from '../libs/@elements/action-changer';
// onInitModulesInScope(actionChanger.initInScope);

import '../libs/theme/modules/sidebar.js';